module.exports = __webpack_public_path__ + "static/9_Copy-5fefb1a802a89998babe502c4af6f107.jpg";